import {connect} from 'react-redux';
import CompareBucketListComponent from './../components/CompareBucketList';
import {MAX_SIZE_COMPARE_BUCKET} from './../constants';
import {removeModelFromCompareBucket} from './../actions';
import compareModelStore from './../storages/CompareModelStore';

const mapStateToProps = (state, ownProps) => ({
    MAX_SIZE: MAX_SIZE_COMPARE_BUCKET,
    currentModel: state.compareBucket.currentModel,
    bucket: state.compareBucket.bucket
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    removeModelFromCompareBucket: (id) => {
        compareModelStore.removeModelFromBucket(id);
        dispatch(removeModelFromCompareBucket(id));
    }
});

export const CompareBucketList = connect(mapStateToProps, mapDispatchToProps)(CompareBucketListComponent);



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/CompareBucketRedux/containers/CompareBucketList.js